import axios from "axios";
import { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { AuthContext } from "context/AuthContext";

export function useLogout() {
  const { signOut } = useContext(AuthContext);

  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        // @ts-ignore
        .delete(`${process.env.REACT_APP_BASE_URL}/auth/logout`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        signOut();
      },
    }
  );
  return {
    loading: isLoading,
    logOut: mutate,
  };
}
